import { useContext, useCallback } from 'react';
import { M as MobileModeChangeSource } from './MobileModeChangeSource-b30fe130.js';
import { M as MobileThemeContext } from './MobileThemeContext-15ca3ea1.js';

// Fake context to cover the case of the hook being used outside the context.
const stubContext = {
  isMobile: false,
  onMobileModeChange: () => undefined,
  browserIsMobile: false
};
function useSetMobileMode() {
  var _ref;
  const {
    isMobile,
    onMobileModeChange,
    browserIsMobile
  } = (_ref = useContext(MobileThemeContext)) !== null && _ref !== void 0 ? _ref : stubContext;
  const setMobileMode = useCallback(mobileMode => {
    onMobileModeChange({
      source: MobileModeChangeSource.User,
      mobileMode
    });
  }, [onMobileModeChange]);
  return {
    isMobile,
    setMobileMode,
    browserIsMobile
  };
}

export { useSetMobileMode as u };
//# sourceMappingURL=useSetMobileMode-ac16c983.js.map
